import './_related-product-option.scss';
import component from './related-product-option';

export default component;
